module.exports = __webpack_public_path__ + "static/media/tiktok.e0274db2.svg";